module.exports = __webpack_public_path__ + "img/Vector_rigth_arrow.088d9491.svg";